export enum VideoReviewTimeMarkerCSSClass {
	Alert = 'vb-icon vb-icon-alert compliance-alert',
	CommentWithPicture = 'manual-comment-picture',
	CommentWithInitials = 'manual-comment-initials'
}

export interface IVideoReviewData {
	complianceAlerts: IVideoReviewAlertEntry[];
	manualComments: IVideoReviewManualCommentEntry[];
	stepMapping: IVideoReviewStepMapping[];
}

export interface IVideoReviewStepMapping {
	stepName: string;
	stepId: string;
	jobId: string | null;
}

export interface IVideoReviewAlertEntry {
	id: string;
	finding: string;
	findingType: VideoReviewFindingType;
	count: number;
	occurrences: Array<{ segment: number; segmentText: string; }>;
	replies: IVideoReviewReplyEntry[];
	stepName: string;
	stepId: string;
	isContainerHighlighted: boolean;
}

export enum VideoReviewFindingType {
	SensitiveData = 'SensitiveData',
	CustomIdentifier = 'CustomDataIdentifiers'
}

export interface IVideoReviewManualCommentEntry {
	id: string;
	comment: string;
	segment: number | null;
	user: ContentReviewEntryUserDetails;
	when: Date;
	replies: IVideoReviewReplyEntry[];
	stepName: string;
	stepId: string;
	isContainerHighlighted: boolean;
}

export interface IVideoReviewReplyEntry {
	reply: string;
	replyId: string;
	commentId?: string;
	findingId?: string;
	user: ContentReviewEntryUserDetails;
	when: Date;
}

export interface ContentReviewDTO {
	approvalProcessId: string;
	approvalProcessName: string;
	complianceAlerts: ContentReviewComplianceAlertDTO[];
	comments: ContentReviewCommentDTO[];
	jobId: string | null;
	stepId: string;
	stepName: string;
}

export interface ApprovalStepFindingsSavedDTO {
	approvalProcessId: string;
	complianceAlerts: ContentReviewComplianceAlertDTO[];
	jobId: string;
	stepId: string;
	stepName: string;
}

export interface ContentReviewComplianceAlertReplyDTO {
	comment: string;
	findingId: string;
	replyId: string;
	stepId: string;
	stepName: string;
	user: ContentReviewEntryUserDetails;
	when: Date;
}

export interface ContentReviewComplianceAlertReplyDeletedDTO {
	findingId: string;
	replyId: string;
	stepId: string;
	stepName: string;
}

export interface ContentReviewManualCommentAddedDTO {
	comment: string;
	id: string;
	segment: string;
	stepId: string;
	stepName: string;
	user: ContentReviewEntryUserDetails;
	when: Date;
}

export interface ContentReviewManualCommentDeletedDTO {
	commentId: string;
	stepId: string;
}

export interface ContentReviewsManualCommentRepliedDTO {
	comment: string; // reply
	id: string; // replyId
	commentId: string;
	stepId: string;
	user: ContentReviewEntryUserDetails;
	when: Date;
}

export interface ContentReviewsManualCommentReplyDeletedDTO {
	commentId: string;
	replyId: string;
	stepId: string;
}

interface ContentReviewComplianceAlertDTO {
	id: string;
	finding: string;
	findingType: string;
	count: number;
	replies: ContentReviewReplyDTO[];
	occurrences: ContentReviewComplianceAlertOccurenceDTO[];
}

interface ContentReviewComplianceAlertOccurenceDTO {
	start: number;
	end: number;
	startColumn: number;
	value: {
		start: string;
		end: string;
		text: string;
	};
}

interface ContentReviewCommentDTO {
	id: string;
	comment: string;
	segment: string | null;
	user: ContentReviewEntryUserDetails;
	when: Date;
	replies: ContentReviewReplyDTO[];
}

interface ContentReviewReplyDTO {
	comment: string; // reply
	commentId?: string;
	findingId?: string;
	id: string; // replyId
	user: ContentReviewEntryUserDetails;
	when: Date;
}

export interface ContentReviewEntryUserDetails {
	id: string;
	fullName: string;
	userName: string;
	profileImageUri: string;
	firstName: string;
	lastName: string;
}
